import React from 'react';

export const ClusterChooserPage = React.lazy(() => import('./ClusterChooser'));
